const types = {
  ACCESS_TOKEN_REQUEST: 'ACCESS_TOKEN_REQUEST',
  ACCESS_TOKEN_SUCCESS: 'ACCESS_TOKEN_SUCCESS',
  ACCESS_TOKEN_FAILURE: 'ACCESS_TOKEN_FAILURE',
  REMOVE_ACCESS_TOKEN: 'REMOVE_ACCESS_TOKEN',
  ACCESS_TOKEN_LOCAL: 'ACCESS_TOKEN_LOCAL',
}

export default types;